import { render, staticRenderFns } from "./AzureLogin.vue?vue&type=template&id=6e354a85&scoped=true&"
import script from "./AzureLogin.vue?vue&type=script&lang=js&"
export * from "./AzureLogin.vue?vue&type=script&lang=js&"
import style0 from "./AzureLogin.vue?vue&type=style&index=0&id=6e354a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e354a85",
  null
  
)

export default component.exports